import { Link } from 'react-router-dom';

export default function About() {
  return (
    <section id="about" className="py-16 md:py-24 bg-gray-900">
      <div className="max-w-7xl mx-auto px-5 lg:px-12">
        <div className="grid lg:grid-cols-5 gap-10 items-center">
          <div className="lg:col-span-3">
            <div className="mb-6">
              <span className="text-teal-400 text-xs font-bold uppercase tracking-wider">Our Philosophy</span>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white mt-3 mb-5">Movement Over Muscle</h2>
              <p className="text-base sm:text-lg text-gray-300 leading-relaxed mb-6">
                We don't follow the traditional Big 5 mentality. At Elite Performance Lab, we revolve our programs around biomechanics and movement patterns that are specific to baseball performance.
              </p>
            </div>

            <div className="space-y-5">
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-11 h-11 flex items-center justify-center bg-teal-500/20 rounded-lg">
                  <i className="ri-pulse-line text-xl text-teal-400"></i>
                </div>
                <div>
                  <h3 className="text-base sm:text-lg font-bold text-white mb-1">Biomechanical Analysis</h3>
                  <p className="text-gray-400 text-sm leading-relaxed">
                    Advanced motion capture and data analysis to identify inefficiencies and optimize throwing mechanics for velocity and injury prevention.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="flex-shrink-0 w-11 h-11 flex items-center justify-center bg-teal-500/20 rounded-lg">
                  <i className="ri-focus-3-line text-xl text-teal-400"></i>
                </div>
                <div>
                  <h3 className="text-base sm:text-lg font-bold text-white mb-1">Movement Pattern Optimization</h3>
                  <p className="text-gray-400 text-sm leading-relaxed">
                    Sport-specific training that enhances natural movement patterns rather than forcing generic strength protocols that don't translate to the field.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="flex-shrink-0 w-11 h-11 flex items-center justify-center bg-teal-500/20 rounded-lg">
                  <i className="ri-line-chart-line text-xl text-teal-400"></i>
                </div>
                <div>
                  <h3 className="text-base sm:text-lg font-bold text-white mb-1">Data-Driven Programming</h3>
                  <p className="text-gray-400 text-sm leading-relaxed">
                    Every decision is backed by objective data from industry-leading technology platforms, ensuring measurable progress and accountability.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/5591532c811aa6761551555e8da592bf.jpg"
                alt="Biomechanical Assessment"
                className="w-full h-72 sm:h-96 lg:h-full object-cover rounded-2xl shadow-2xl"
              />
              <div className="absolute -bottom-4 -left-4 sm:-bottom-6 sm:-left-6 bg-white p-4 sm:p-6 rounded-xl shadow-xl">
                <div className="text-3xl sm:text-4xl font-black text-gray-900">18+</div>
                <div className="text-xs sm:text-sm font-semibold text-gray-600 uppercase">Years Experience</div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="bg-gray-800 p-6 sm:p-8 rounded-2xl border border-teal-500/20 hover:border-teal-500/40 transition-all">
            <div className="text-4xl sm:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-teal-600 mb-2">
              60+
            </div>
            <div className="text-xs sm:text-sm font-bold text-gray-400 uppercase tracking-wide mb-2">College Athletes</div>
            <div className="flex items-center gap-2 text-teal-400 text-xs">
              <i className="ri-arrow-up-line"></i>
              <span className="font-medium">Growing Daily</span>
            </div>
          </div>

          <div className="bg-gray-800 p-6 sm:p-8 rounded-2xl border border-teal-500/20 hover:border-teal-500/40 transition-all">
            <div className="text-4xl sm:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-teal-600 mb-2">
              8
            </div>
            <div className="text-xs sm:text-sm font-bold text-gray-400 uppercase tracking-wide mb-2">Pro Players</div>
            <div className="flex items-center gap-2 text-teal-400 text-xs">
              <i className="ri-arrow-up-line"></i>
              <span className="font-medium">Growing Daily</span>
            </div>
          </div>

          <div className="bg-gray-800 p-6 sm:p-8 rounded-2xl border border-teal-500/20 hover:border-teal-500/40 transition-all">
            <div className="text-4xl sm:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-teal-600 mb-2">
              2021
            </div>
            <div className="text-xs sm:text-sm font-bold text-gray-400 uppercase tracking-wide mb-2">Full-Time Since</div>
            <div className="flex items-center gap-2 text-teal-400 text-xs">
              <i className="ri-check-line"></i>
              <span className="font-medium">November</span>
            </div>
          </div>

          <div className="bg-gray-800 p-6 sm:p-8 rounded-2xl border border-teal-500/20 hover:border-teal-500/40 transition-all">
            <div className="text-4xl sm:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-teal-600 mb-2">
              100%
            </div>
            <div className="text-xs sm:text-sm font-bold text-gray-400 uppercase tracking-wide mb-2">College Placement</div>
            <div className="flex items-center gap-2 text-teal-400 text-xs">
              <i className="ri-medal-line"></i>
              <span className="font-medium">2+ Year Athletes as of 2026</span>
            </div>
          </div>
        </div>

        {/* Six Pillars Section */}
        <div className="mt-20">
          <div className="text-center mb-12">
            <span className="text-teal-400 text-xs font-bold uppercase tracking-wider">Our Foundation</span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white mt-3 mb-5">Our Six Pillars</h2>
            <p className="text-base sm:text-lg text-gray-300 leading-relaxed max-w-3xl mx-auto">
              The core principles that drive every training decision and athlete transformation at Elite Performance Lab.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
            {/* Pillar 1 */}
            <div className="bg-gray-800 p-6 rounded-2xl border border-teal-500/20 hover:border-teal-500/40 transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-500/20 rounded-lg">
                  <i className="ri-speed-line text-2xl text-teal-400"></i>
                </div>
                <span className="text-xs font-black text-teal-400 uppercase tracking-widest">Pillar 1</span>
              </div>
              <h3 className="text-lg font-bold text-white mb-2">Proprioception Training</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                Controlling the body in time and space. The bridge between physical capacity and usable athletic performance — strength without control is wasted potential.
              </p>
            </div>

            {/* Pillar 2 */}
            <div className="bg-gray-800 p-6 rounded-2xl border border-cyan-500/20 hover:border-cyan-500/40 transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 flex items-center justify-center bg-cyan-500/20 rounded-lg">
                  <i className="ri-flashlight-line text-2xl text-cyan-400"></i>
                </div>
                <span className="text-xs font-black text-cyan-400 uppercase tracking-widest">Pillar 2</span>
              </div>
              <h3 className="text-lg font-bold text-white mb-2">Active Range of Motion</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                AROM training and assessment for high school athletes. Growth and strength gains mean nothing if the athlete cannot control their body through full, symmetrical ranges.
              </p>
            </div>

            {/* Pillar 3 */}
            <div className="bg-gray-800 p-6 rounded-2xl border border-emerald-500/20 hover:border-emerald-500/40 transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 flex items-center justify-center bg-emerald-500/20 rounded-lg">
                  <i className="ri-flashlight-fill text-2xl text-emerald-400"></i>
                </div>
                <span className="text-xs font-black text-emerald-400 uppercase tracking-widest">Pillar 3</span>
              </div>
              <h3 className="text-lg font-bold text-white mb-2">Impulse Training</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                Force applied over a short period of time. The rate at which an athlete reaches maximum speed often matters more than the speed itself — explosive, fast-twitch, dynamic movement.
              </p>
            </div>

            {/* Pillar 4 */}
            <div className="bg-gray-800 p-6 rounded-2xl border border-amber-500/20 hover:border-amber-500/40 transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 flex items-center justify-center bg-amber-500/20 rounded-lg">
                  <i className="ri-rocket-line text-2xl text-amber-400"></i>
                </div>
                <span className="text-xs font-black text-amber-400 uppercase tracking-widest">Pillar 4</span>
              </div>
              <h3 className="text-lg font-bold text-white mb-2">Fast Twitch Muscle Fibers</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                Training for in-game demands. Speed before strength, intent before load — train to access fast twitch fibers consistently, not exhaust them.
              </p>
            </div>

            {/* Pillar 5 */}
            <div className="bg-gray-800 p-6 rounded-2xl border border-violet-500/20 hover:border-violet-500/40 transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 flex items-center justify-center bg-violet-500/20 rounded-lg">
                  <i className="ri-mental-health-line text-2xl text-violet-400"></i>
                </div>
                <span className="text-xs font-black text-violet-400 uppercase tracking-widest">Pillar 5</span>
              </div>
              <h3 className="text-lg font-bold text-white mb-2">Central Nervous System</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                The CNS adapts to what it is rewarded for. Understanding how to train the nervous system is the difference between athletes who perform under pressure and those who fade.
              </p>
            </div>

            {/* Pillar 6 */}
            <div className="bg-gray-800 p-6 rounded-2xl border border-rose-500/20 hover:border-rose-500/40 transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 flex items-center justify-center bg-rose-500/20 rounded-lg">
                  <i className="ri-brain-line text-2xl text-rose-400"></i>
                </div>
                <span className="text-xs font-black text-rose-400 uppercase tracking-widest">Pillar 6</span>
              </div>
              <h3 className="text-lg font-bold text-white mb-2">Mentality & Process</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                Your mind is the control center of your body. What you repeatedly think and say programs your nervous system for either confidence or hesitation. As you think, so you perform.
              </p>
            </div>
          </div>

          <div className="text-center">
            <Link 
              to="/pillars"
              className="inline-flex items-center gap-2 bg-teal-500 hover:bg-teal-600 text-white font-bold px-8 py-4 rounded-lg transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <span>Explore Our Six Pillars</span>
              <i className="ri-arrow-right-line text-lg"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
